module.exports = __webpack_public_path__ + "7e4b29ba/img/document.e2130c6b.svg";